import { render } from "./Mortgage.vue?vue&type=template&id=8aa0bfbc&scoped=true"
import script from "./Mortgage.vue?vue&type=script&lang=js"
export * from "./Mortgage.vue?vue&type=script&lang=js"

import "./Mortgage.vue?vue&type=style&index=0&id=8aa0bfbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa0bfbc"]])

export default __exports__